import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    slideRoot: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    title: {
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(3),
        fontSize: "24px !important",
        width: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        textAlign: "start",
    },
    graphContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        position: "relative",
        padding: `${theme.spacing(3)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
        flex: 1,
        minHeight: 0,
    },
    graphGridItemContainer: {
        height: "100%",
    },
}));
